import { MutationHookOptions, MutationTuple, useMutation } from '@apollo/client';

import {
  CreateAscProjectMutation,
  CreateAscProjectMutationVariables,
  CREATE_ASC_PROJECT,
  evictCache,
} from '@neo.tax/shared';

type UseCreateAscProject = MutationTuple<CreateAscProjectMutation, CreateAscProjectMutationVariables>;

export const useCreateAscProject = (
  options?: MutationHookOptions<CreateAscProjectMutation, CreateAscProjectMutationVariables>,
): UseCreateAscProject =>
  useMutation<CreateAscProjectMutation, CreateAscProjectMutationVariables>(CREATE_ASC_PROJECT, {
    context: {
      successToast: {
        title: 'Project created successfully',
      },
      errorToast: {
        title: 'Error creating project',
        description: 'Something unexpected prevented your changes from saving. Please try again.',
      },
    },
    update: (cache) => {
      // Evict all cached getAscProjects queries to force a refetch.
      // refetchQueries doesn't work because the cached query has additional variables
      // (filter, sorting, paging) that don't match the basic refetch variables.
      evictCache(cache, ['getAscProjects']);
    },
    ...options,
  });
